import React from "react";
import { useTranslation } from "react-i18next";
// import processusImage from '../../../public/assets/landingPageImages/processPEC.webp';

const ProcessusDePriseEnCharge = () => {
  const { t } = useTranslation();
  return (
    <section className="processus-section py-5">
      <div className="container">
        <div className="section-title text-center mb-5">
          <h6 className="sub-title">{t("process.subtitle")}</h6>
          <h2 className="title">
            {t("process.title.before")}{" "}
            <span>{t("process.title.highlight")}</span>{" "}
            {t("process.title.after")}
          </h2>
        </div>

        <div className="row align-items-center">
          {/* Left: Paragraph */}
          <div className="col-md-6 mb-4 mb-md-0" style={{ fontSize: "18px" }}>
            <div className="px-md-4">
              <p className="lh-lg">{t("process.paragraph1")} <strong>{t("process.hnam3ak")}</strong>  {t("process.paragraphe1-suite")}</p>
              <p className="lh-lg">
                <strong className="text-secondary">
                  {t("process.paragraph2.strong")}
                </strong>
                , {t("process.paragraph2.rest")}
              </p>
              <p className="lh-lg">
                {t("process.paragraph3.before")}
                <strong className="text-secondary">
                  {t("process.paragraph3.strong")}
                </strong>
                {t("process.paragraph3.after")}
              </p>
            </div>
          </div>

          {/* Right: Image */}
          <div className="col-md-6 text-center">
            <img
              src="/assets/landingPageImages/process1.png"
              alt="Schéma du processus"
              className="img-fluid mx-auto d-block"
              style={{ maxWidth: "550px" }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessusDePriseEnCharge;
